import { StyledSpinner } from "./styled";

const Spinner = () => <StyledSpinner />;

export default Spinner;